import PropTypes from 'prop-types';
import capitalize from '~/helpers/capitalize';

const UserRoleSelector = ({ readOnly, role, roleList, onRoleChanged, inputName, className }) => {
  if (readOnly) return <input className={className} id={inputName} name={inputName} readOnly value={role} />;
  return (
    <select className={className} id={inputName} name={inputName} onChange={onRoleChanged} defaultValue={role}>
      {roleList.map((roleItem) => (
        <option key={roleItem} value={roleItem}>
          {capitalize(roleItem)}
        </option>
      ))}
    </select>
  );
};

UserRoleSelector.defaultProps = {
  readOnly: false,
  inputName: 'role',
  className: 'form-input',
};

UserRoleSelector.propTypes = {
  readOnly: PropTypes.bool,
  inputName: PropTypes.string,
  role: PropTypes.string.isRequired,
  roleList: PropTypes.arrayOf(PropTypes.string).isRequired,
  onRoleChanged: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default UserRoleSelector;
